export default "__VITE_ASSET__CEua4ruM__"